import {
  handleClaimNowClick,
  handleRewardTicketClick,
  mapRewardStatusToIcon,
} from 'helpers/dashboardUtils';
import {
  getRuntimeEnvVariables,
  getReverseFormattedDob,
} from 'helpers/Utils';
import {
  dashboardLoginDashboardAnchorClickEvent,
  loginDashboardRewardsClaimNowEvent,
  loginDashboardRewardsDetailsEvent,
} from 'components/tracking';

const useRewards = (props) => {
  // eslint-disable-next-line eqeqeq
  const showRewardsModule = getRuntimeEnvVariables('RUNTIME_ENABLE_REWARD_SELECTION') == 'true';
  if (!showRewardsModule) { return null; }

  const {
    ALL_VERTICALS_FILTER,
    baseURL,
    dashboardModules,
    history,
    images,
    rewards,
    setViewAllRewards,
    staticText,
    toggleRewardPasswordModal,
    track,
    viewAllRewards,
    viewAllRewardsText,
  } = props;

  const rewardStatusLevel = {
    NORMAL: 'NORMAL',
    WARNING: 'WARNING',
    DANGER: 'DANGER',
  };

  const rewardsStatusStage = {
    PREREGISTRATION: 'PREREGISTRATION',
  };

  function toggleViewAllRewards() {
    setViewAllRewards(!viewAllRewards);
  }

  function getRewardsFilters() {
    const filters = [
      {
        val: ALL_VERTICALS_FILTER,
        name: staticText.DASHBOARD_REWARDS_MODULE_TITLE,
      },
    ];

    return filters;
  }

  function getRewardsData(_baseURL) {
    function getStatusCTA({
      status, fulfilment, rewardHeader, details, ctaButton,
    }) {
      function showRewardPasswordModal() {
        toggleRewardPasswordModal(fulfilment[0], rewardHeader);
      }

      if (fulfilment && fulfilment[0]?.url && handleClaimNowClick) {
        return () => {
          handleClaimNowClick({
            rewardRedeemRoute: fulfilment[0]?.url,
            showRewardPasswordModal,
          });
          loginDashboardRewardsClaimNowEvent(track, details);
        };
      }

      if (status === rewardsStatusStage.PREREGISTRATION && handleClaimNowClick) {
        return () => {
          handleClaimNowClick({
            // eslint-disable-next-line react/prop-types
            rewardRedeemRoute: ctaButton?.link?.url,
          });
          // TODO: Add tracking once requirements are defined
        };
      }

      return null;
    }

    return rewards?.map(({
      campaign,
      details,
      validUntil,
      currentStatus,
      statusLevel,
      fulfilment,
      ctaButton,
      rewardId,
    }) => {
      // eslint-disable-next-line react/prop-types
      const rewardHeader = campaign?.header;
      let shortDescription;
      if (details) {
        shortDescription = details.description?.shortDescription;
      } else {
        shortDescription = campaign?.shortDescription;
      }
      return ({
        title: rewardHeader,
        subTitle: shortDescription,
        bottomTextLabel: staticText.REWARDS_MODULE_VALID_UNTIL,
        bottomTextValue: getReverseFormattedDob(validUntil, '-', '/'),
        onClick: handleRewardTicketClick && rewardId && (() => {
          handleRewardTicketClick({
            history,
            rewardMoreInfoRoute: `${_baseURL}/${staticText.DASHBOARD_REWARD_ROUTE_NAME}/${rewardId}`,
          });
          loginDashboardRewardsDetailsEvent(track, details);
        }),
        status: {
          icon: mapRewardStatusToIcon[currentStatus?.key],
          name: currentStatus?.display,
          error: statusLevel === rewardStatusLevel.DANGER,
          onClick: getStatusCTA({
            status: currentStatus?.key, fulfilment, ctaButton, rewardHeader, details,
          }),
        },
      });
    });
  }

  const rewardsModule = {
    id: dashboardModules.REWARDS,
    menuTitle: staticText.REWARDS_MODULE_ANCHOR,
    onAnchorClick: () => dashboardLoginDashboardAnchorClickEvent(track, 'rewards'),
    rewards: {
      emptyHeader: staticText.REWARDS_MODULE_HEADER,
      emptySubheader: staticText.REWARDS_MODULE_EMPTY_STATE_HEADER,
      emptyDescription: staticText.REWARDS_MODULE_EMPTY_STATE_DESCRIPTION,
      hideCTA: true,
      reminderTitle: staticText.REWARDS_MODULE_REMINDER_TITLE,
      reminderText: staticText.REWARDS_MODULE_REMINDER_TEXT,
      emptyImageSrc: images?.ADD_REWARD?.image?.url,
      data: getRewardsData(baseURL),
      filters: getRewardsFilters(),
      onViewAllClick: toggleViewAllRewards,
      viewAllText: viewAllRewardsText,
    },
  };
  return rewardsModule;
};

export default useRewards;
